import posthog from 'posthog-js';
import { useEffect } from 'react';
import { Outlet, useNavigationType } from 'react-router-dom';
import { authorizeUrl } from '.';
import { useGetProfileQuery } from '../api';
import { Spinner } from '../components/Spinner';
import { AuthenticatedUserContext } from './AuthenticatedUserContext';

export const RequireAuthentication = () => {
  const navigationType = useNavigationType();
  const { data, isLoading, error, isSuccess, refetch } = useGetProfileQuery();

  useEffect(() => {
    if (navigationType.toString() === 'POP') {
      refetch();
    }
  }, [navigationType, refetch]);

  useEffect(() => {
    if (data) {
      const { id, tenant, roles, hidden } = data;
      const subtenants = data.subtenants?.map(({ name }) => name);
      posthog.identify(id, { tenant, subtenants, roles, hidden });
    }
  }, [data]);

  if (isLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (!isSuccess || error || !data) {
    const returnPath = location.pathname + location.search;
    sessionStorage.setItem('returnPath', returnPath);

    location.replace(authorizeUrl());

    return;
  }

  return (
    <AuthenticatedUserContext.Provider value={data}>
      <Outlet />
    </AuthenticatedUserContext.Provider>
  );
};
